import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '@/util/helpers'

// initial state
const state = {
  stories: [],
  storiesPagination: {},
  story: {}
}

// getters
const getters = {
  stories: state => state.stories,
  storiesPagination: state => state.storiesPagination,
  story: state => state.story
}

// actions
const actions = {
  getStories({ state, commit }, args) {
    return Vue.axios.get(`/stories/`, {
      params: args.params,
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_STORY_LIST, { response })
    })
  },
  getStory({ state, commit }, args) {
    return Vue.axios.get(`/stories/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_STORY, { response })
    })
  },
  createStory({ state, commit }, args) {
    return Vue.axios.post(
      `/stories/`,
      args
    ).then((response) => {
      commit(types.RECEIVE_STORY, { response })
    })
  },
  saveStory({ state, commit }, args) {
    return Vue.axios.put(
      `/stories/${state.story.id}/`, state.story, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_STORY, { response })
    })
  },
  deleteStory({ state, commit }, args) {
    return Vue.axios.delete(`/stories/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_STORY, { response })
    })
  },
  addStoryTag({ state, commit }, args) {
    return Vue.axios.post(`/stories/${args.story_id}/tags/${args.tag_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_STORY_VALUE, { story_tags: response.data.results.story_tags })

    })
  },
  deleteStoryTag({ state, commit }, args) {
    return Vue.axios.delete(`/stories/${args.story_id}/tags/${args.tag_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_STORY_VALUE, { story_tags: response.data.results.story_tags })
    })
  },
  addStoryAuthor({ state, commit }, args) {
    return Vue.axios.post(`/stories/${args.story_id}/authors/${args.author_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_STORY_VALUE, { authors: response.data.results.authors })
    })
  },
  deleteStoryAuthor({ state, commit }, args) {
    return Vue.axios.delete(`/stories/${args.story_id}/authors/${args.author_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_STORY_VALUE, { authors: response.data.results.authors })
    })
  },
  uploadStoryCover({ state, commit }, args) {
    return Vue.axios.post(`/stories/${args.id}/upload-cover/`,
      args.formEncodedData,
      {
        headers: args.headers || null
      }
    )
      .then(function (response) {
        commit(types.RECEIVE_STORY, { response })
      })
  },
  uploadStoryPodcastImage({ state, commit }, args) {
    return Vue.axios.post(`/stories/${args.id}/upload-podcast-image/`,
      args.formEncodedData,
      {
        headers: args.headers || null
      }
    )
      .then(function (response) {
        commit(types.RECEIVE_STORY, { response })
      })
  },
  uploadStoryAttachment({ state, commit }, args) {
    return Vue.axios.post(`/stories/${args.storyId}/upload-attachment/`,
      args.formEncodedData,
      {
        headers: args.headers || null
      }
    )
      .then(function (response) {
        commit(types.UPDATE_STORY_VALUE, { attachments: response.data.results.attachments })
      })
  },
  deleteStoryAttachment({ state, commit }, args) {
    return Vue.axios.delete(`/stories/${args.storyId}/attachments/${args.attachmentId}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_STORY_VALUE, { attachments: response.data.results.attachments })
    })
  },
  addStoryRelated({ state, commit }, args) {
    return Vue.axios.post(`/stories/${args.story_id}/related/${args.related_story_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_STORY_VALUE, { related_stories: response.data.results.related_stories })

    })
  },
  deleteStoryRelated({ state, commit }, args) {
    return Vue.axios.delete(`/stories/${args.story_id}/related/${args.related_story_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_STORY_VALUE, { related_stories: response.data.results.related_stories })
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_STORY](state, { response }) {
    state.story = response.data.results
  },
  [types.RECEIVE_STORY_LIST](state, { response }) {
    state.stories = response.data.results
    state.storiesPagination = helpers.pagination(response.headers)
  },
  [types.RECEIVE_STORY_TAGS_LIST](state, { response }) {
    state.storyTagsList = response.data.results
  },
  [types.RECEIVE_STORY_CLASSES_LIST](state, { response }) {
    state.storyClassesList = response.data.results
  },
  [types.UPDATE_STORY_VALUE](state, value) {
    state.story = Object.assign(state.story, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
